<template>
  <div class="dvs">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="headerPage">
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12 d-flex contentHeader"
            :style="{ opacity: !isMachineSelected ? 1 : 0 }"
          >
            <div class="inputGroup col-lg-6">
              <span>Selecione uma máquina:</span>
              <multiselect
                v-model="machineSelected"
                :options="machines"
                track-by="id"
                label="name"
                placeholder="Selecione uma máquina"
                :searchable="true"
                :allow-empty="true"
                :clear-on-select="false"
                :close-on-select="true"
                :disabled="isMachineSelected"
                @input="openModal('confirm-modal')"
              />
            </div>
            <small v-if="!isMachineSelected"
              >{{ machines.length }} máquinas cadastradas</small
            >
          </div>
          <div
            class="col-12 d-flex contentHeaderRight"
            v-if="securityValidation.id"
          >
            <!-- <div class="icon">
              <a :href="getExportUrl()" target="_blank">
                <font-awesome-icon style="color: white" icon="print" />
              </a>
            </div> -->
            <PdfExportProgress
              v-if="exportingPdf"
              :state="dvsExportState.current_state"
              :progress="dvsExportState.progress_percentage"
              :status="dvsExportState.status"
              :expected-completion-at="dvsExportState.expected_completion_at"
            />
            <b-dropdown v-else text="Exportar" class="m-md-2">
              <b-dropdown-item @click="exportPdf()"
                >PDF</b-dropdown-item
              >
              <!-- <b-dropdown-item>CSV</b-dropdown-item> -->
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group col-md-4 mt-2">
      <label>
        Responsável Técnico
        <span>*</span>
      </label>
      <multiselect
        v-model="selectedResponsibles"
        :options="technicalResponsibles"
        track-by="id"
        label="technical_responsible_name"
        placeholder="Selecione os Responsáveis Técnicos"
        :multiple="true"
        :clear-on-select="false"
        :close-on-select="false"
        :allow-empty="true"
        :hide-selected="true"
        :disabled="!canAccess()"
      >
      </multiselect>
    </div>
    <b-modal
      ref="confirm-modal"
      title="Novo DVS"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="openModal('number-code-modal')"
    >
      Deseja criar uma DVS para a máquina: {{ machineSelected.name }}
      <template v-slot:modal-cancel>Não</template>
      <template v-slot:modal-ok>Sim</template>
    </b-modal>
    <b-modal
      ref="number-code-modal"
      title="Novo DVS"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="createDVS"
    >
      <input
        type="text"
        v-model="number_code"
        placeholder="Número do documento"
        ref="numbe_code_ref"
        class="form-control"
        disabled
      />
      <template v-slot:modal-cancel>Não</template>
      <template v-slot:modal-ok>Sim</template>
    </b-modal>
    <div
      class="container-fluid"
      :style="{ opacity: !isMachineSelected ? 0 : 1 }"
    >
      <div class="row">
        <div class="col-12 navBarSection">
          <div
            class="navBarItem"
            v-bind:class="{ active: isSelectedSection('dvs') }"
            v-on:click="selectSection('dvs')"
          >
            <font-awesome-icon icon="suitcase" />
            <span>MÁQUINAS</span>
          </div>
          <div
            class="navBarItem"
            v-bind:class="{ active: isSelectedSection('anexos') }"
            v-on:click="selectSection('anexos')"
          >
            <font-awesome-icon icon="paperclip" />
            <span>ANEXOS</span>
          </div>
        </div>
      </div>
      <div class="row attachments" v-if="isSelectedSection('anexos')">
        <div class="col-8" v-if="localCompanyId && id">
          <AttachmentsList
            :company_id="localCompanyId"
            :machine_id="securityValidation.machine_id"
            typeDocument="security_validation"
            :document_id="id"
            :readonly="!edit_permission"
          ></AttachmentsList>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="isSelectedSection('dvs')">
      <div class="row">
        <div
          v-for="dvs in dvsList"
          v-bind:key="dvs.name"
          class="col-12 machineDVS"
        >
          <SecurityValidation
            :dvs="dvs"
            :readonly="!edit_permission"
            ref="securityValidation"
            @dvsChange="dvs = $event"
            :selectedResponsibles="selectedResponsibles"
            :company_id="localCompanyId"
          ></SecurityValidation>
          <!-- <Accordion>
            <template v-slot:title>
              <span class="textGray">Máquina:</span>
              {{dvs.machine.name}}
            </template>
            <template v-slot:body>
              <SecurityValidation :dvs="dvs"></SecurityValidation>
            </template>
          </Accordion>-->
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-padding">
          <b-alert v-show="alert" :variant="alert_type" show>{{
            alert_msg
          }}</b-alert>
          <b-alert
            dismissible
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            fade
            :show="dismissCountDown"
            variant="warning"
            >Você possui um ou mais dispositivos de segurança sem salvar. Por
            favor, salve tudo para continuar</b-alert
          >
          <div class="alertError" style="width: 100%; height: 50px"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Accordion from "@/components/Accordion.vue";
import axios from "@/api/axios";
import AttachmentsList from "@/components/AttachmentsList.vue";
import PdfExportProgress from "@/components/PdfExportProgress.vue";
import SecurityValidation from "@/components/SecurityValidation.vue";
import { canAccess } from "@/utils/canAccess";
import moment from "moment";
import Multiselect from "vue-multiselect";
export default {
  name: "DVS",
  components: {
    // Accordion,
    SecurityValidation,
    AttachmentsList,
    PdfExportProgress,
    Multiselect
  },
  props: {
    id: String,
    company_id: String,
  },
  watch: {
    company_id(newVal) {
      this.localCompanyId = newVal;
      if (newVal) {
        this.getCompany(newVal);
      }
    },
  },
  data() {
    return {
      selectedSection: "dvs",
      exportingPdf: false,
      attachmentWarningShown: false,
      dvsExportState: {
        status: "pending",
        current_state: null,
        progress_percentage: 0,
        expected_completion_at: null
      },
      componentDestroyed: false,
      localCompanyId: this.company_id || localStorage.getItem('company_id'),
      company: {},
      isMachineSelected: false,
      securityValidation: {},
      machineSelected: "0",
      number_code: "",
      technicalResponsibles: [],
      selectedResponsibles: [],
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        {
          text: "",
          href: `#/admin/Documents/Company/${this.company_id || localStorage.getItem('company_id')}`,
        },
        {
          text: "DVS's",
          href: `#/admin/Documents/ListDocuments/${this.company_id || localStorage.getItem('company_id')}/DVS`,
        },
        {
          text: "DVS",
          active: true,
        },
      ],
      dvsList: [],
      machines: [],
      is: false,
      role: localStorage.getItem("auth.role"),
      edit_permission: this.role != "client" || !this.id,
      dismissSecs: 8,
      dismissCountDown: 0,
      alert: false,
      alert_type: "success",
      alert_msg: "Item salvo com sucesso",
    };
  },
  mounted: async function() {
    const loader = this.$loading.show();
    this.edit_permission = this.role != "client" || !this.id;
    if (this.localCompanyId) {
      this.getCompany(this.localCompanyId);
    }
    await this.getTechnicalResponsibles();
    if (this.id) {
      await this.getDVS();
      this.isMachineSelected = true;
      this.resumeDvsExport();
    } else {
      await this.getMachinesByCompanyId();
      await this.generateNumberCode();
    }
    loader.hide();
  },
  beforeDestroy() {
    this.componentDestroyed = true;
  },
  methods: {
    canAccess,
    getCompany: function (company_id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}`)
        .then((response) => {
          this.items[1].text = response.data.data.corporate_name;
        });
    },
    getMachinesByCompanyId: async function () {
      const response = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/machines?company_id=${this.localCompanyId}`,
        {
          params: {
            reduced: true,
            not_paginated: true,
            not_gallery: true,
          },
        }
      );
      this.machines = response.data.data;
    },
    getTechnicalResponsibles:async function(){
      await axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/companies/${this.localCompanyId}/technical-responsible`
        ).then((response)=>{
          this.technicalResponsibles= response.data;
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    getDVS: async function () {
      await axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/security-validations/${this.id}?include=protection-devices`
        )
        .then((response) => {
          this.securityValidation = response.data;
          this.dvsList.push(this.securityValidation);
          this.selectedResponsibles = response.data.technicals;
        });
    },
    generateNumberCode: async function () {
      await axios
        .get(
          `${
            process.env.VUE_APP_API_HOST
          }/api/admin/get-document-count-by-user/${localStorage.getItem(
            "auth.user_id"
          )}`
        )
        .then((response) => {
          let userCode = localStorage.getItem("auth.user_id").substring(0, 4);
          let date = moment().format("YY.MM.DD");
          this.number_code = `${date}.${userCode}.${response.data}`;
        });
    },
    createDVS: async function (modaEvent) {
      if (this.number_code && this.number_code != "") {
        this.isMachineSelected = true;
        await axios
          .post(
            `${process.env.VUE_APP_API_HOST}/api/admin/security-validations`,
            {
              number_code: this.number_code,
              machine_id: this.machineSelected.id,
              executed_at: moment().format("YYYY-MM-DD"),
              technical_responsibles: this.selectedResponsibles
            }
          )
          .then(async (response) => {
            this.id = response.data.id;
            await axios
              .post(
                `${process.env.VUE_APP_API_HOST}/api/admin/store-security-validation-user`,
                {
                  user_id: localStorage.getItem("auth.user_id"),
                  security_validation_id: this.id,
                }
              )
              .then((response) => {
                this.securityValidation = response.data;
                this.securityValidation.machine = this.machineSelected;
                this.dvsList.push(this.securityValidation);
              })
              .catch(() => {
                this.warning = true;
              });
          })
          .catch(() => {
            this.warning = true;
          });
      } else {
        modaEvent.preventDefault();
        this.$refs.numbe_code_ref.focus();
      }
    },
    selectSection: function (section) {
      this.selectedSection = section;
    },
    isSelectedSection: function (section) {
      return this.selectedSection == section;
    },
    addDevice: function () {
      this.securityValidation.protection_devices.push({});
    },
    openModal: function (modal) {
      this.$refs[modal].show();
    },
    getExportUrl: function () {
      return `${process.env.VUE_APP_API_HOST}/export-security-validation/${this.securityValidation.id}.pdf`;
    },
    getDvsExportStorageKey() {
      return `dvsPdfExport:${this.securityValidation.id}`;
    },
    saveDvsExportToStorage(payload) {
      localStorage.setItem(this.getDvsExportStorageKey(), JSON.stringify(payload));
    },
    clearDvsExportFromStorage() {
      localStorage.removeItem(this.getDvsExportStorageKey());
    },
    resumeDvsExport() {
      const raw = localStorage.getItem(this.getDvsExportStorageKey());
      if (!raw) {
        return;
      }
      let stored;
      try {
        stored = JSON.parse(raw);
      } catch (error) {
        this.clearDvsExportFromStorage();
        return;
      }
      if (!stored || !stored.statusUrl) {
        return;
      }
      this.exportingPdf = true;
      this.resetDvsExportState();
      this.pollPdfStatus(stored.statusUrl).then(() => {
        this.exportingPdf = false;
      });
    },
    async exportPdf() {
      if (this.exportingPdf) {
        return;
      }
      this.exportingPdf = true;
      this.attachmentWarningShown = false;
      this.resetDvsExportState();

      const loader = this.$loading.show();
      let data;
      try {
        const response = await axios.get(this.getExportUrl());
        data = response.data;
      } catch (error) {
        loader.hide();
        this.exportingPdf = false;
        const message = error.response?.data?.message || 'Não foi possível gerar o PDF do DVS.';
        this.$bvToast.toast(message, {
          title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        });
        return;
      }
      loader.hide();
      this.showAttachmentWarning(data);

      if (data.status === 'completed' && data.download_url) {
        window.open(data.download_url, '_blank');
        this.exportingPdf = false;
        return;
      }

      this.applyDvsExportStatus(data);

      this.$bvToast.toast('Gerando o PDF do DVS em segundo plano. Você será avisado quando estiver pronto.', {
        title: 'Exportação', variant: 'info', solid: true, toaster: 'b-toaster-top-right',
      });

      this.saveDvsExportToStorage({ statusUrl: data.status_url });
      await this.pollPdfStatus(data.status_url);
      this.exportingPdf = false;
    },
    async pollPdfStatus(statusUrl) {
      if (!statusUrl) {
        return;
      }

      let pollDelay = this.dvsExportState.status === 'pending' ? 10000 : 3000;
      let consecutiveErrors = 0;

      while (!this.componentDestroyed) {
        await new Promise((resolve) => setTimeout(resolve, pollDelay));

        if (this.componentDestroyed) {
          return;
        }

        try {
          const { data } = await axios.get(statusUrl, { params: { _t: Date.now() } });
          this.showAttachmentWarning(data);
          consecutiveErrors = 0;
          this.applyDvsExportStatus(data);
          pollDelay = data.status === 'pending' ? 10000 : 3000;

          if (data.status === 'completed' && data.download_url) {
            this.clearDvsExportFromStorage();
            this.$bvToast.toast('PDF do DVS pronto para download.', {
              title: 'Exportação', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
            });
            window.open(data.download_url, '_blank');
            return;
          }

          if (data.status === 'failed') {
            this.clearDvsExportFromStorage();
            this.$bvToast.toast(data.message || data.error_message || 'Falha ao gerar PDF do DVS.', {
              title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
            });
            return;
          }
        } catch (error) {
          consecutiveErrors += 1;
          pollDelay = 10000;
          if (consecutiveErrors >= 5) {
            this.clearDvsExportFromStorage();
            this.$bvToast.toast('Não foi possível consultar o status do PDF. Tente novamente.', {
              title: 'Erro', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
            });
            return;
          }
        }
      }
    },
    resetDvsExportState() {
      this.dvsExportState = {
        status: 'pending',
        current_state: null,
        progress_percentage: 0,
        expected_completion_at: null,
      };
    },
    applyDvsExportStatus(data) {
      this.dvsExportState = {
        status: data.status || this.dvsExportState.status,
        current_state: data.status === 'pending'
          ? 'Aguardando para começar...'
          : data.current_state,
        progress_percentage: data.progress_percentage || 0,
        expected_completion_at: data.status === 'processing'
          ? (data.expected_completion_at || null)
          : null,
      };
    },
    showAttachmentWarning(data) {
      const warning = data && data.attachment_warning;
      if (!warning || this.attachmentWarningShown) {
        return;
      }

      this.attachmentWarningShown = true;
      this.$bvToast.toast(warning.message, {
        title: 'Anexos não incluídos',
        variant: 'warning',
        solid: true,
        toaster: 'b-toaster-top-right',
        autoHideDelay: 12000,
      });
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("alertError")[0];
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    let canLeave = true;
    if (this.isMachineSelected) {
      this.$refs.securityValidation.forEach((sv) => {
        if (sv.$refs.protectionDevice) {
          sv.$refs.protectionDevice.forEach((el) => {
            if (el.alert_type == "warning") {
              this.dismissCountDown = this.dismissSecs;
              this.scrollToElement();
              canLeave = false;
              next(false);
            }
          });
        }
      });
      if (canLeave) {
        this.$refs.securityValidation[0].alert_type = "success";
        this.$refs.securityValidation[0].alert_msg = "Item Salvo com sucesso";
        this.$refs.securityValidation[0].alert = true;
        next();
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "src/styles/General.scss";
@import "src/styles/DVS.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
